export default __webpack_public_path__ + "static/media/480_business02-fr-mobile.534236c7.png";